import axios from "axios";
import { baseUrl, buildQuery } from "../config/api-config";

const base = `${baseUrl}`;

export function getCaseDocuments (token, caseId, query) {
    const q = buildQuery(query);
    return axios.get(`${baseUrl}/case/${caseId}/docs${q}`, {
        headers: {
            authorization: token
        }
    });
}

export function getDocumentById (token, docId) {
    return axios.get(`${baseUrl}/case/doc/${docId}`, {
        headers: {
            authorization: token
        },
        responseType: "blob"
    })
}

export function deleteDocumentById (token, docId) {
    return axios.delete(`${baseUrl}/case/doc/${docId}`, {
        headers: {
            authorization: token
        }
    });
}


export function uploadDocs (token, caseId, formData) {
    return axios({
        url: `${baseUrl}/case/${caseId}/docs`,
        method: 'POST',
        data: formData,
        headers: {
            'Authorization': token,
            'Content-Type': 'multipart/form-data'
        }
    });
}